// ============================================================
// Accurate Automation and Reconditioners — Central content store.
// Update image URLs and text here to swap real assets later.
// ============================================================

export const COMPANY = {
  name: "Accurate",
  fullName: "Accurate Automation and Reconditioners",
  legal: "Accurate Automation and Reconditioners",
  tagline: "Precision Engineered. Future Ready.",
  qualityPolicyPdf: "https://customer-assets-m6fa6gv7.emergentagent.net/job_machine-solutions-1/artifacts/mbnbb4y9_Quality%20Policy%20Certificate%20%281%29.pdf",
  logo: "/brand/accurate-logo.png",
  officePhone: "+91 98902 21433",
  phone: "+91 94235 73311",
  whatsapp: "919890221433",
  email: "accurate@accurateautomation.net",
  address: "Gat No. 1A, Plot No. 21 & 22, Atul Industrial Premises, MIDC Talawade, Dehu–Alandi Road, Pimpri-Chinchwad, Pune, Maharashtra – 411062, India",
  hours: "Friday – Wednesday · 9:00 AM – 6:00 PM · Thursday Closed",
  mapUrl: "https://maps.app.goo.gl/Gmxr4T8QmCbCLd4S8",
  linkedin: "https://www.linkedin.com/company/accurate-automation-&-reconditioners/",
  mapEmbed:
    "https://www.google.com/maps?q=18.7034867,73.7873033&hl=en&z=16&output=embed",
  founded: 2004,
};

export const STATS = [
  { value: 20, suffix: "+", label: "Years of Engineering" },
  { value: 850, suffix: "+", label: "Machines Reconditioned" },
  { value: 320, suffix: "+", label: "Clients Across India" },
  { value: 99, suffix: "%", label: "Uptime Delivered" },
];

export const SERVICES = [
  { slug: "cnc-retrofitting", title: "CNC Retrofitting", short: "Transform legacy machines into modern CNC powerhouses with FANUC & Siemens controls.", icon: "cpu",
    desc: "We convert conventional and outdated CNC machines into high-precision, production-ready systems using the latest FANUC and Siemens control platforms — extending machine life by decades." },
  { slug: "machine-reconditioning", title: "Machine Reconditioning", short: "Full mechanical and electrical restoration to factory-grade accuracy.", icon: "wrench",
    desc: "Complete strip-down, geometry correction, and rebuild of machine tools to restore original — or better — accuracy, rigidity, and repeatability." },
  { slug: "plc-programming", title: "PLC Programming", short: "Custom ladder logic and automation sequences engineered for reliability.", icon: "code",
    desc: "Bespoke PLC programming across Siemens S7, FANUC and Allen-Bradley platforms for machines, cells and complete production lines." },
  { slug: "servo-integration", title: "Servo Integration", short: "Precision servo drives and motor tuning for flawless motion control.", icon: "activity",
    desc: "Integration and tuning of digital servo systems for axis motion, spindle drives, and multi-axis synchronisation with micron-level precision." },
  { slug: "mechanical-overhauling", title: "Mechanical Overhauling", short: "Spindle, ballscrew and slideway rebuilds for peak rigidity.", icon: "settings",
    desc: "Overhaul of spindles, ballscrews, LM guideways and gearboxes — restoring the mechanical backbone of your machine tool." },
  { slug: "electrical-upgrades", title: "Electrical Upgrades", short: "Modern panels, safety circuits and IE-compliant wiring.", icon: "zap",
    desc: "Complete electrical panel redesign, safety-circuit compliance, and wiring upgrades to current industrial standards." },
  { slug: "installation-commissioning", title: "Installation & Commissioning", short: "Turnkey installation with full acceptance testing.", icon: "truck",
    desc: "End-to-end installation, alignment, and commissioning with documented acceptance testing and operator handover." },
  { slug: "preventive-maintenance", title: "Preventive Maintenance", short: "Scheduled care that eliminates unplanned downtime.", icon: "shield",
    desc: "Condition-based and scheduled maintenance programmes engineered to maximise availability and prevent costly breakdowns." },
  { slug: "amc", title: "Annual Maintenance Contracts", short: "Guaranteed response and uptime, all year round.", icon: "calendar",
    desc: "Comprehensive AMC packages with priority response SLAs, genuine spares, and predictable maintenance budgeting." },
  { slug: "machine-calibration", title: "Machine Calibration", short: "Laser calibration and ballbar testing to ISO standards.", icon: "target",
    desc: "Laser interferometry, ballbar and geometric calibration certified to ISO 230 for verified, traceable accuracy." },
];

// Real machine photos from client. PENSOTTI keeps stock as no photo was provided.
const IMG_VTL = "https://images.unsplash.com/photo-1716191299980-a6e8827ba10b?auto=format&fit=crop&w=1200&q=80";
const IMG_HMC = "/machines/wmw-union-hmc.png";
const IMG_TURNING = "/machines/cincinnati-erd.png";
const IMG_HBM = "/machines/jurastic-hbm.png";
const IMG_VMC = "/machines/okuma-va50.png";

export const MACHINES = [
  {
    id: "pensotti-vtl",
    name: "PENSOTTI VTL",
    type: "PENSOTTI VTL",
    controller: "FANUC OITF plus",
    condition: "Available for Purchase",
    tags: ["VTL", "FANUC"],


    image: "/machines/pensotti-vtl.png",
    gallery: ["/machines/pensotti-vtl.png"],


    specs: {
      "Make": "PENSOTTI",
      "CNC": "FANUC OITF plus",
      "Warranty": "1 year for system",
      "Pneumatic power chuck size": "1000 mm",
      "Swing": "1400 mm",
      "Height": "1100 mm",
      "Spindle rpm": "260 rpm",
      "Spindle power": "30 hp",
      "ATC": "12 tools, through tool coolant",
      "Coolant system": "Yes",
      "Accuracy": "0.01 per/ mtr",
      "Lubrication": "Automatic lubrication system"
    },


    features: [
      "FANUC OITF plus CNC",
      "1000 mm Pneumatic Power Chuck",
      "1400 mm Swing",
      "12-Tool ATC with Through Tool Coolant"
    ]
  },
  {
    id: "niles-vtl",
    name: "NILES VTL",
    type: "NILES VTL",
    controller: "FANUC OITF plus",
    condition: "Available for Purchase",
    tags: ["VTL", "FANUC"],

    image: "/machines/niles-vtl.png",
    gallery: ["/machines/niles-vtl.png"],

    specs: {
      "Make": "WMW NILES",
      "Availability": "Available for Purchase",
      "CNC": "FANUC OITF plus",
      "Chuck size": "1450 mm",
      "Swing": "1600 mm",
      "Height": "900 mm",
      "Spindle servo motor": "Yes",
      "Spindle rpm": "120 rpm",
      "Spindle power": "30 hp",
      "Accuracy": "0.01 per/ mtr",
      "Coolant system": "Provision",
      "Lubrication": "Automatic lubrication system"
    },

    features: [
      "FANUC OITF plus CNC",
      "1450 mm Chuck",
      "1600 mm Swing",
      "Spindle Servo Motor"
    ]
  },
  {
    id: "stanko-3c-vtl",
    name: "STANKO 3C VTL",
    type: "STANKO 3C VTL",
    controller: "FANUC OITF plus",
    condition: "Available for Purchase",
    tags: ["VTL", "FANUC"],
    image: "/machines/stanko-vtl.png",
    gallery: ["/machines/stanko-vtl.png"],
    specs: {
      "Make": "STANKO 3C VTL",
      "Availability": "Readily available",
      "Turret": "Manual Turret",
      "CNC": "FANUC OITF plus",
      "Warranty": "1 year for system",
      "Chuck size": "1150 mm",
      "Swing": "1300 mm",
      "Height": "1000 mm",
      "Spindle rpm": "160 rpm",
      "Spindle power": "30 hp",
      "Accuracy": "0.01 per/ mtr",
      "Coolant system": "Provision",
      "Lubrication": "Automatic lubrication system"
    },
    features: [
      "FANUC OITF plus CNC",
      "1150 mm Chuck",
      "1300 mm Swing",
      "Manual Turret"
    ],
  },
  {
    id: "ohm-vtl",
    name: "OHM VTL",
    type: "OHM VTL",
    controller: "FANUC OITF plus",
    condition: "Available for Purchase",
    tags: ["VTL", "FANUC"],

    image: "/machines/ohm-vtl.png",
    gallery: ["/machines/ohm-vtl.png"],

    specs: {
      "Make": "OHM",
      "CNC": "FANUC OITF plus",
      "Warranty": "1 year for system",
      "Chuck size": "1200 mm",
      "Swing": "1500 mm",
      "Height": "1000 mm",
      "Spindle rpm": "160 rpm",
      "Spindle power": "30 hp",
      "Accuracy": "0.01 per/ mtr",
      "Lubrication": "Automatic lubrication system"
    },

    features: [
      "FANUC OITF plus CNC",
      "1200 mm Chuck",
      "1500 mm Swing",
      "30 hp Spindle Power"
    ]
  },
  {
    id: "stanko-3c-vtl-auto-turret",
    name: "STANKO 3C VTL AUTO TURRET",
    type: "STANKO 3C VTL",
    controller: "FANUC OITF plus",
    condition: "Available for Purchase",
    tags: ["VTL", "FANUC"],

    image: "/machines/stanko-2-vtl.png",
    gallery: ["/machines/stanko-2-vtl.png"],

    specs: {
      "Make": "STANKO 3C",
      "CNC": "FANUC OITF plus",
      "Warranty": "1 year for system",
      "Chuck size": "1150 mm",
      "Swing": "1300 mm",
      "Auto turret": "Yes",
      "Height": "1000 mm",
      "Spindle rpm": "160 rpm",
      "Spindle power": "30 hp",
      "Accuracy": "0.01 per/ mtr",
      "Coolant system": "Provision",
      "Lubrication": "Automatic lubrication system"
    },

    features: [
      "FANUC OITF plus CNC",
      "1150 mm Chuck",
      "1300 mm Swing",
      "Auto Turret"
    ]
  },
  { 
    id: "wmw-union-hmc", 
    name: "WMW UNION HMC", 
    type: "Horizontal Machining Center", 
    controller: "Siemens 828D", 
    condition: "Available for Purchase", 
    tags: [], 
    image: "/machines/wmw-union-hmc.png", 
    gallery: ["/machines/wmw-union-hmc.png"], 
 
    specs: { 
      "Make": "WMW Union", 
      "X Axis": "1,600 mm", 
      "Y Axis": "1,250 mm", 
      "Z Axis": "900 mm", 
      "B Axis (Rotary Table)": "0.001° indexable (NC Rotary Table)", 
      "Feed Rate (X / Y / Z)": "0.001 – 5 m/min", 
      "Rapid Traverse (X / Y / Z)": "10 m/min", 
      "Tool Holder": "SK 50", 
      "Spindle Speed": "50 – 3,600 RPM", 
      "Spindle Orientation": "Through Encoder", 
      "Spindle Motor": "36 KW", 
      "ATC No. of Tools": "60", 
      "Tool Changer": "ARM Type", 
      "Tool Magazine": "Through Gear Box, Driven Through VFD", 
      "Number of Pallets": "2", 
      "Pallet Dimension": "1,000 × 1,000 mm", 
      "Max. Table Load": "2,000 kg", 
      "Pallet Changer": "Motor Driven with Chain Drive", 
      "Coolant System": "Coolant Tank Along with Pump", 
      "Space Requirement (L × W × H)": "8 × 6 × 4 m" 
    }, 
 
    features: [ 
      "Siemens 828D CNC controller", 
      "0.001° indexable NC rotary table", 
      "SK 50 spindle and tool holder", 
      "36 KW spindle motor", 
      "60-tool automatic tool changer", 
      "2-pallet changer system", 
      "1,000 × 1,000 mm pallet dimension", 
      "Maximum table load of 2,000 kg", 
      "VFD-driven tool magazine", 
      "Coolant tank with pump" 
    ] 
  },
  {
    id: "cincinnati-turning-center",
    name: "CINCINNATI TURNING CENTER",
    type: "CINCINNATI TURNING CENTER",
    controller: "FANUC OiTF Plus CNC Controller",
    condition: "Available for Purchase",
    tags: ["Turning Center", "FANUC"],

    image: "/machines/cincinnati-erd.png",
    gallery: ["/machines/cincinnati-erd.png"],

    specs: {
      "MAKE": "CINCINNATI",
      "Model": "ERD",
      "CNC": "FANUC OiTF Plus CNC Controller",
      "Chuck Dia": "250 mm",
      "Swing": "350 mm",
      "ABC": "1200 mm",
      "Spindle Speed": "1500 RPM",
      "Spindle Bore": "A 2- 5",
      "Turret": "Diplomatic Turret 8 Station (Heavy Duty)",
      "Automatic lubrication": "Yes",
      "Flood Coolant": "Yes",
      "Chip convey our": "scrapper type",
      "Repeatability / Accuracy": "0.010 mm"
    },

    features: [
      "FANUC OiTF Plus CNC Controller",
      "250 mm Chuck Dia",
      "8 Station Heavy Duty Turret",
      "Flood Coolant & Scrapper Type Chip Conveyor"
    ]
  },
  {
    id: "moriseiki-turning-center",
    name: "MORISEIKI TURNING CENTER",
    type: "MORISEIKI TURNING CENTER",
    controller: "FANUC OiTF Plus CNC Controller",
    condition: "Available for Purchase",
    tags: ["Turning Center", "FANUC"],

    image: "/machines/moriseiki-sl3.png",
    gallery: ["/machines/moriseiki-sl3.png"],

    specs: {
      "Make": "MORISEIKI",
      "Model": "SL -3",
      "CNC": "FANUC OiTF Plus CNC Controller",
      "Spindle": "15 Hp",
      "Chuck Dia": "250 mm",
      "Swing": "320 mm",
      "ABC": "600 mm",
      "Spindle Speed": "2200 RPM",
      "Spindle Bore": "A 2- 5",
      "Turret": "8 Station (Motorized)",
      "Automatic lubrication": "Yes",
      "Coolant system": "Yes"
    },

    features: [
      "FANUC OiTF Plus CNC Controller",
      "250 mm Chuck Dia",
      "8 Station Motorized Turret",
      "2200 RPM Spindle Speed"
    ]
  },
  {
    id: "scottish-machine-tools",
    name: "SCOTTISH MACHINE TOOLS (UK) LATHE",
    type: "SCOTTISH MACHINE TOOLS",
    controller: "FANUC OI TF CNC Controller",
    condition: "Available for Purchase",
    tags: ["Heavy Duty", "FANUC"],

    image: "/machines/scottish-turning.png",
    gallery: ["/machines/scottish-turning.png"],

    specs: {
      "Make": "Scottish Machine Tools (UK)",
      "CNC": "FANUC OI TF CNC Controller",
      "Chuck Diameter": "2300 mm",
      "Swing over bed": "2800 mm",
      "Swing over on carriage": "approx. 2200 mm",
      "Admit between center (ABC)": "5000 mm approx.",
      "Chuck": "Four jaw chuck",
      "Chuck RPM": "40",
      "Headstock": "Geared headstock",
      "Gear Box lubrication": "Automatic",
      "Slide lubrication": "Automatic",
      "Tailstock": "Tailstock with motorized movement",
      "Tailstock sleeve Diameter": "200 mm",
      "Sleeve Movement": "manual",
      "Guideways": "Box Guideways (All Guideways grinding done)",
      "Accuracy": "0.05 mm",
      "Tool Post": "Square tool post 4 station",
      "Approx. Weight": "58 Tons",
      "Machine Status": "Ready to take production"
    },

    features: [
      "Fanuc OI TF CNC Controller",
      "2300 mm Four Jaw Chuck",
      "5000 mm ABC",
      "58 Tons Approx. Weight"
    ]
  },
  {
    id: "jurastic-hbm",
    name: "JURASTIC HBM",
    type: "Horizontal Boring Machine",
    controller: "FANUC 0i-TF",
    condition: "Under Retrofitting",
    tags: [],
    image: "/machines/jurastic-hbm.png",
    gallery: ["/machines/jurastic-hbm.png"],

    specs: {
      "X Axis": "3,000 mm",
      "Y Axis": "2,000 mm",
      "Z Axis": "2,000 mm",
      "W Axis": "700–800 mm",
      "B Axis": "0.001° index rotary table",
      "Table Size": "2,000 × 2,000 mm",
      "Load Capacity": "~18,000 kg",
      "Feed Rate": "0.001–5 m/min",
      "Rapid Traverse (X/Y/Z)": "8 / 6 / 8 m/min",
      "Repeatability": "0.010 mm / m",
      "Spindle Tool Holder": "ISO 50",
      "Spindle Speed": "50–1,250 rpm",
      "Spindle Motor": "22 kW / 30 HP",
      "Machine Weight": "38–40 Tons"
    },

    features: [
      "Encoder feedback",
      "0.001° indexable rotary table",
      "ISO 50 spindle",
      "ISO geometry"
    ]
  },
  {
    id: "okuma-vmc-va-50",
    name: "OKUMA VMC MODEL VA 50",
    type: "Vertical Machining Center",
    controller: "SYNTEC CNC Controller",
    condition: "Available for Purchase",
    tags: [],
    image: "/machines/okuma-va50.png",
    gallery: ["/machines/okuma-va50.png"],

    specs: {
      "Table Size": "1,200 × 600 mm",
      "X Axis": "1,050 mm",
      "Y Axis": "550 mm",
      "Z Axis": "550 mm",
      "Height": "1,000 mm",
      "Spindle Speed": "4,500 RPM",
      "Spindle Taper": "ISO 50",
      "Automatic Lubrication": "Yes",
      "Chilling Unit": "Yes",
      "Flood Coolant": "Yes",
      "Repeatability / Accuracy": "0.010 mm"
    },

    features: [
      "SYNTEC CNC controller",
      "Automatic lubrication",
      "Chilling unit",
      "Flood coolant",
      "ISO 50 spindle taper"
    ]
  },
];

export const CONTROLLERS = [
  { brand: "FANUC", tagline: "The world standard in CNC control",
    image: "https://images.unsplash.com/photo-1716191299980-a6e8827ba10b?auto=format&fit=crop&w=1200&q=80",
    desc: "As FANUC specialists, we deliver retrofits and integrations across the full FANUC series — from the compact 0i to the high-end 31i/32i platforms — engineered for reliability in the most demanding production environments.",
    series: ["Series 0i-MF / 0i-TF", "Series 31i / 32i", "Power Motion i", "αi / βi Servo Drives"],
    points: ["Nano interpolation for superior surface finish", "AI contour control & look-ahead", "Integrated safety & smart machining", "Global spare-parts availability"] },
  { brand: "SIEMENS", tagline: "SINUMERIK — intelligent machining",
    image: "https://images.pexels.com/photos/8956445/pexels-photo-8956445.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    desc: "Our certified engineers implement SINUMERIK control systems across 808D, 828D and 840D sl platforms — unlocking advanced digitalisation, ShopMill/ShopTurn programming and seamless Industry 4.0 connectivity.",
    series: ["SINUMERIK 808D", "SINUMERIK 828D", "SINUMERIK 840D sl", "SINAMICS Drives"],
    points: ["ShopMill & ShopTurn cycles", "Digital twin & MindSphere ready", "Advanced 5-axis transformations", "Integrated Safety Integrated"] },
];

export const INDUSTRIES = [
  { name: "Industrial Machinery", icon: "heart-pulse", desc: "CNC machine components, repairs, retrofitting, upgrades & maintenance" },
  { name: "Heavy Engineering", icon: "box", desc: "Large components, heavy machining, machine reconditioning & rebuilding" },
  { name: "Automotive", icon: "car", desc: "Precision components & powertrain machining." },
  { name: "Aerospace", icon: "plane", desc: "Tight-tolerance structural & engine parts." },
  { name: "Energy & Power", icon: "zap", desc: "Turbine, valve & heavy-component work." },
  { name: "General Engineering", icon: "cog", desc: "Job-shop and batch production support." },
];

export const PROJECTS = [
  { id: "titan-vtl", title: "TITAN VTL - RAM Type", industry: "Heavy Engineering",
    image: "/projects/titan-vtl.png", beforeImage: "/projects/titan-vtl-before.png",
    scope: "Full retrofit and reconditioning of a Ram-type TITAN Vertical Turret Lathe.",
    challenge: "Ageing controls, worn mechanicals and inconsistent accuracy on large diameter components.",
    solution: "Complete mechanical overhaul, geometry recalibration and CNC retrofit, delivered production-ready.",
    result: "Restored precision, reliability and production capability with a fresh mechanical baseline." },
   { id: "bullard-vtl", title: "BULLARD VTL", industry: "Engineering & Manufacturing",
    image: "/projects/bullard-vtl.png", beforeImage: "/projects/bullard-vtl-before.jpeg",
    scope: "CNC retrofit and reconditioning of a BULLARD VTL as per customer requirements, with conversion from Siemens CNC control to FANUC CNC control.",
    challenge: "The existing Siemens CNC control system required replacement to meet the customer's preferred FANUC control platform, while ensuring reliable operation and compatibility with the machine's existing mechanical and electrical systems.",
    solution: "Reconditioned the machine with a complete Siemens-to-FANUC CNC conversion and control integration.",
    result: "Successfully delivered a reliable, production-ready BULLARD VTL with FANUC CNC control, improved control usability and renewed machine performance in line with the customer's requirements."},
  { id: "stanko-3c-vtl-project", title: "STANKO 3C VTL", industry: "Heavy Engineering",
    image: "/projects/stanko-3c.png ", beforeImage: "/projects/stanko-3c-before.jpeg",
    scope: "Reconditioning and CNC integration of a STANKO 3C Vertical Turret Lathe.",
    challenge: "Mechanical wear and outdated controls limited the machine's productivity.",
    solution: "Comprehensive rebuild, spindle servo motor upgrade and FANUC 0i-TF Plus retrofit.",
    result: "Machine returned to duty with modern diagnostics and dependable ±0.01 mm/m accuracy." },
  { id: "sculfort-lathe", title: "SCULFORT LATHE", industry: "Aerospace & Defence",
    image: "/projects/sculfort-lathe.png", beforeImage: "/projects/sculfort-lathe-before.png",
    scope: "Retrofit of a SCULFORT precision lathe for aerospace component machining.",
    challenge: "Aerospace-grade tolerances required upgraded controls and calibrated geometry.",
    solution: "Complete mechanical inspection, slideway and ballscrew refurbishment, and CNC retrofit.",
    result: "Delivered to Skyroot Aerospace as a reliable production asset for critical aerospace parts." },
  { id: "dynacut-vtl", title: "DYNACUT VTL", industry: "Industrial Manufacturing",
    image: "/projects/dynacut-vtl.jpg", beforeImage: "/projects/dynacut-vtl-before.jpg",
    scope: "Reconditioning of a DYNACUT Vertical Turret Lathe for Kirloskar Pneumatic.",
    challenge: "Restoring the DYNACUT to modern production standards while preserving its mechanical strengths.",
    solution: "Mechanical rebuild, control replacement and full acceptance testing before dispatch.",
    result: "Machine returned to production with restored accuracy and predictable performance." },
  { id: "hobbing-machine", title: "HOBBING MACHINE", industry: "Gear Manufacturing",
    image: "/projects/hobbing-machine.jpg", beforeImage: "/projects/hobbing-machine-before.jpg",
    scope: "Reconditioning of a hobbing machine for gear-cutting production.",
    challenge: "Restore accuracy for gear-tooth profile within acceptable industrial tolerances.",
    solution: "Full mechanical rebuild, indexing calibration and modern electrical panel upgrade.",
    result: "Gear-cutting performance restored with predictable, repeatable quality." },
  { id: "moriseiki-zl3", title: "MORI SEIKI ZL-3 MACHINE", industry: "Precision Engineering",
    image: "/projects/moriseiki-zl3.png", beforeImage: "/projects/moriseiki-zl3-before.png",
    scope: "Reconditioning and CNC upgrade of a MORI SEIKI ZL-3 turning centre.",
    challenge: "Ageing electronics and inconsistent turret indexing limited output.",
    solution: "Servo drive upgrade, turret indexing overhaul, and advanced CNC retrofit.",
    result: "Reliable turning centre performance with modern diagnostics and warranty backing." },
  { id: "cooper-machine", title: "COOPER MACHINE", industry: "Heavy Engineering",
    image: "/projects/cooper-vmc.png", beforeImage: "/projects/cooper-vmc-before.png",
    scope: "Reconditioning of a COOPER heavy machine tool.",
    challenge: "Legacy mechanicals required full inspection and modern control integration.",
    solution: "Slideway regrinding, spindle overhaul and CNC upgrade — commissioned with documented acceptance.",
    result: "Extended machine life with contemporary performance and diagnostics." },
  { id: "hitachi-seiki", title: "HITACHI SEIKI MACHINE", industry: "Precision Manufacturing",
    image: "/projects/hitachi-seiki.png", beforeImage: "/projects/hitachi-seiki-before.png",
    scope: "Reconditioning of a HITACHI SEIKI machining centre.",
    challenge: "Restore original Japanese-quality precision on an ageing platform.",
    solution: "Mechanical inspection, control replacement and full calibration to ISO acceptance standards.",
    result: "Renewed production asset with a fresh service life and modern control experience." },
];

export const GALLERY = [
  { src: "/machines/bullard-vtl.png", cat: "VTL" },
  { src: "/machines/cincinnati-erd.png", cat: "TURNING CENTER" },
  { src: "/machines/colchester.png", cat: "TURNING CENTER" },
  { src: "/machines/dynacut-vtl-machine.jpg", cat: "VTL" },
  { src: "/machines/jurastic-hbm.png", cat: "HBM" },
  { src: "/machines/moriseiki-sl3.png", cat: "TURNING CENTER" },
  { src: "/machines/niles-vtl.png", cat: "VTL" },
  { src: "/machines/ohm-vtl.png", cat: "VTL" },
  { src: "/machines/okuma-va50.png", cat: "VMC" },
  { src: "/machines/pensotti-vtl.png", cat: "VTL" },
  { src: "/machines/scottish-turning.png", cat: "LATHE MACHINE" },
  { src: "/machines/sculfort-lathe.png", cat: "LATHE MACHINE" },
  { src: "/machines/stanko-2-vtl.png", cat: "VTL" },
  { src: "/machines/stanko-vtl.png", cat: "VTL" },
  { src: "/machines/titan-vtl-machine.png", cat: "VTL" },
  { src: "/machines/wmw-union-hmc.png", cat: "HMC" },
  { src: "/machines/hitachi-seiki-cnc.png", cat: "TURNING CENTER" },
  { src: "/machines/cooper-vmc.png", cat: "VMC" },
  { src: "/machines/hobbing-machine.jpg", cat: "HOBBING MACHINE" },
  { src: "/machines/moriseiki-zl3-cnc.png", cat: "TURNING CENTER" },
];
export const CLIENTS = [
  "AMTEK", "Bosch", "ZF India", "Unique Circle Engineering Pvt. Ltd.", "Godrej",
  "Kirloskar Pneumatic", "Rajkumar Forge Ltd.", "Ratna Gears", "Maharashtra Seamless",
  "Premium Transmission", "SVL Industries", "Yashodhan Engineering", "Lohia Corp",
  "Bhavani Steel Forging Industries", "Jailaxmi Alloys and Steels Pvt Ltd",
  "Challenge Autotech Pvt. Ltd.", "Rath Enterprises", "Bajaj", "HAAS", "NECO",
  "Skyroot Aerospace", "Kirloskar Oil Engines", "Tyco", "Mahindra & Mahindra",
  "TAL", "Whirlpool", "Spicer", "AHCPL Cold Form", "Bharat Forge | Kalyani",
  "Tata Motors",
];

export const TESTIMONIALS = [
  { name: "Rajesh Menon", role: "Plant Head, Tier-1 Auto Supplier", quote: "Accurate transformed our ageing machine fleet into a modern, reliable production line. Their FANUC expertise is unmatched in the region.", rating: 5 },
  { name: "Anita Desai", role: "Operations Director, Aerospace OEM", quote: "The Siemens integration was flawless. Documented, on-time, and the results exceeded our acceptance criteria.", rating: 5 },
  { name: "Vikram Shah", role: "Maintenance Manager, Bearing Manufacturer", quote: "Our reconditioned HBM performs better than when it was new. The precision restoration was truly world-class.", rating: 5 },
  { name: "Sunil Kapoor", role: "MD, Precision Components", quote: "A dependable engineering partner. Their AMC keeps our entire shop floor running without surprises.", rating: 5 },
];

export const PRIMARY_CERTIFICATION = {
  name: "ISO 9001:2008 Certified Company",
  subtitle: "Quality Management System",
  desc: "Certified to ISO 9001:2008 standards, reflecting our commitment to consistent quality, reliable processes, and customer satisfaction.",
};

export const TECHNICAL_CREDENTIALS = [
  { name: "FANUC CNC Systems", desc: "Verified CNC integration & control expertise." },
  { name: "Siemens CNC Systems", desc: "Verified CNC integration & SINUMERIK expertise." },
];

export const UDYAM_REGISTRATION = {
  name: "Udyam Registered Enterprise",
  subtitle: "Micro Enterprise · Government of India",
  desc: "Registered as a Micro Enterprise under the Government of India's Udyam scheme.",
  regNo: "UDYAM-MH-26-0131601",
};

export const ACCREDITATIONS = [
  { name: "NABCB", desc: "National Accreditation Board for Certification Bodies" },
  { name: "TÜV NORD", desc: "Certification & Quality Assurance" },
  { name: "IAF", desc: "International Accreditation Forum" },
];

export const CERTIFICATIONS = [
  { name: "ISO 9001:2008", desc: "Quality Management System" },
  { name: "FANUC Certified", desc: "CNC integration & controls" },
  { name: "Siemens Certified", desc: "SINUMERIK integration" },
  { name: "NABCB Accredited", desc: "Independent verification" },
];

export const LEADERSHIP = [
  { name: "Ramanjaneyalu Kenche", role: "Founder & Managing Director",
    bio: "Brings 25+ years of expertise in machine tool engineering, CNC systems, and strategic business leadership.",
    linkedin: "https://www.linkedin.com/in/ramanjaneyalu-kenche-99928a29b" },
  { name: "Akash Kenche", role: "Director — Engineering & Operations",
    bio: "Leads engineering, automation, CNC controls, and technical operations across FANUC and Siemens platforms.",
    linkedin: "https://www.linkedin.com/in/akash-kenche-a03743319" },
  { name: "Amulya Kenche", role: "Manager — Analytics & Procurement",
    bio: "Oversees procurement, project coordination, analytics, quality tracking, and customer service support.",
    linkedin: "https://www.linkedin.com/in/amulyakenche" },
];

export const CAREERS = [
  { title: "Mechanical Fitter – CNC Machine Reconditioning", type: "Full-time", location: "Pune", exp: "3–6 yrs", dept: "Engineering" },
  { title: "CNC Electrical & Automation Engineer", type: "Full-time", location: "Pune", exp: "2–5 yrs", dept: "Automation" },
  { title: "Service & Commissioning Engineer", type: "Full-time", location: "Field / Pan-India", exp: "2–4 yrs", dept: "Service" },
  { title: "Machine Assembly & Installation Technician", type: "Full-time", location: "Pune", exp: "4–8 yrs", dept: "Workshop" },
];

export const PROCESS = [
  { step: "01", title: "Assessment", desc: "On-site machine audit, geometry check, and requirement analysis." },
  { step: "02", title: "Engineering", desc: "Detailed retrofit design, BOM, and project plan with acceptance criteria." },
  { step: "03", title: "Execution", desc: "Mechanical, electrical and control work by certified engineers." },
  { step: "04", title: "Commissioning", desc: "Calibration, acceptance testing, and operator handover." },
  { step: "05", title: "Support", desc: "Warranty, AMC, and lifetime spare-parts backing." },
];

export const VALUES = [
  { title: "Precision", desc: "Micron-level accuracy is our baseline, not our goal." },
  { title: "Integrity", desc: "Honest engineering advice and transparent delivery." },
  { title: "Innovation", desc: "Latest control platforms and automation, applied practically." },
  { title: "Reliability", desc: "We build machines — and relationships — that last." },
];

export const FAQS = [
  { q: "Which controllers do you specialise in?", a: "We are specialists in FANUC and Siemens (SINUMERIK) control systems, covering everything from compact controls to high-end 5-axis platforms." },
  { q: "Do you provide a warranty on retrofits?", a: "Yes. Warranty is provided where applicable for each CNC system, subject to the specified terms and conditions. We also provide mechanical support and service to ensure continued machine performance and support after the retrofit." },
  { q: "Can you retrofit any brand of machine?", a: "We retrofit most makes and models of machine tools. Our engineers assess each machine and recommend the optimal control and drive solution." },
  { q: "How long does a typical retrofit take?", a: "It depends on scope, but most control retrofits are completed within a few weeks, planned around your production schedule to minimise downtime." },
  { q: "Do you sell reconditioned machines?", a: "Yes. Browse our Machines for Sale catalogue — every machine is fully reconditioned, tested, and backed by warranty." },
];
